import { formatUtcDatetimeToColombian } from "@/helpers/time";
import {
  documentLabel,
  propertyUseLabels,
  sourceLabels,
  statusLabels,
} from "./mappers/screening.mapper";
import { Screening } from "./types";

export const formatDocument = (
  tenant: Pick<Screening, "tenantDocumentType" | "tenantDocumentNumber">
) => documentLabel(tenant.tenantDocumentType, tenant.tenantDocumentNumber);

export const formatPhone = (phone: string) =>
  /^57\d{10}$/.test(phone)
    ? `+57 ${phone.slice(2, 5)} ${phone.slice(5, 8)} ${phone.slice(8)}`
    : `+${phone}`;

export const canCreateContract = (screening: Screening) =>
  screening.status === "approved" && !screening.contractId;

export const SCREENING_TABLE_COLUMNS = [
  {
    key: "tenantDocumentNumber",
    label: "Documento",
    width: "1fr",
    minWidth: 150,
    exportTransform: formatDocument,
  },
  {
    key: "tenantName",
    label: "Arrendatario",
    width: "2fr",
    minWidth: 200,
    exportTransform: (screening: Screening) => screening.tenantName,
  },
  {
    key: "propertyAddress",
    label: "Inmueble",
    width: "2fr",
    minWidth: 200,
    exportTransform: (screening: Screening) => screening.propertyAddress ?? "",
  },
  {
    key: "propertyUse",
    label: "Uso",
    width: "1fr",
    minWidth: 100,
    exportTransform: (screening: Screening) =>
      screening.propertyUse ? propertyUseLabels[screening.propertyUse] : "",
  },
  {
    key: "monthlyRent",
    label: "Canon",
    width: "1fr",
    minWidth: 130,
    exportTransform: (screening: Screening) => screening.monthlyRent,
  },
  {
    key: "status",
    label: "Estado",
    width: "1fr",
    minWidth: 140,
    exportTransform: (screening: Screening) => statusLabels[screening.status],
  },
  {
    key: "source",
    label: "Canal",
    width: "1fr",
    minWidth: 170,
    exportTransform: (screening: Screening) => sourceLabels[screening.source],
  },
  {
    key: "createdAt",
    label: "Creado",
    width: "1fr",
    minWidth: 200,
    exportTransform: (screening: Screening) =>
      formatUtcDatetimeToColombian(screening.createdAt),
  },
  {
    key: "actions",
    label: "",
    width: "1fr",
    minWidth: 110,
  },
] as const;
